




























































































































































import { mapGetters } from 'vuex'
import { AxiosResponse } from 'axios'
import { coreKaizen } from '@/common/coreKaizen'
import { Component } from 'vue-property-decorator'
import { certificacionModel } from '@/models/certificaciones/certificacionModel';
import { ticketLogModel } from '@/models/kaizen/ticketLogModel';
import { tipoEntidadModel } from '@/models/certificaciones/tipoEntidadModel'
import { tipoCertificacionModel } from '@/models/certificaciones/tipoCertificacionModel'
import { extraAmountModel } from '@/models/certificaciones/extraAmountModel';
import timeline from '@/components/kaizen/timeLine.vue'
import router from '@/router';
import printJS from 'print-js'

const namespace: string = 'oidcStore/';
@Component({
    components: {
        timeline
    },
    computed: {
        ...mapGetters(namespace, [
            'oidcIdToken'
        ])
    }
})
export default class statusActual extends coreKaizen {
    emptyEntidad: certificacionModel = {
        boleta: 0,
        certificacion: { correlativo: 0, ejercicio: 0 },
        registro: '',
        folio: 0,
        libro: 0,
        descripcion: '',
        expediente: { correlativo: 0, ejercicio: 0 },
        extranjera: false,
        fechaPublicacion: new Date(),
        fechaTra: new Date(),
        fechaTra2: new Date(),
        organizacion: '',
        solicitante: { nombre: '', telefono: '', direccion: '', dpi: '', e_mail: '' },
        ticket: 0,
        tipoCertificacion: 0,
        tipoEntidad: 0,
        titular: { numero: '', tipo: '' },
        referenceData: {
            dataFound: false, items: [
                {
                    titular: { numero: '', tipo: '' },
                    expediente: { correlativo: 0, ejercicio: 0 },
                    extranjera: false,
                    registro: '',
                    folio: 0,
                    libro: 0,
                    id: '',
                    name: '',
                    props: []
                }
            ]
        }
    }
    tipoCertificacion: string = ''
    tipoEntidad: string = ''
    entidad: certificacionModel = this.emptyEntidad
    certiHint: string = 'Ingrese la certificaci\u{f3}n, sin a\u{f1}o'
    ejercicioLabel: string = 'Seleccione el valor que corresponde al a\u{f1}o de la certiciaci\u{f3}n'
    certi: string = ''
    ejercicios: number[] = []
    ejercicio: number = new Date().getFullYear()
    validCerti: boolean = false
    descripcion: string = ''
    RFLRules: any = [(v: string) => !!v || 'Campo requerido']
    fileNames: string[] = [];
    currentPage: number = 1
    pageCount: number = 0
    downloadingCertificacion: boolean = false
    loadingTask: any = null
    loadedDocument: boolean = false
    snackBarText: string = ''
    snackbar: boolean = false
    isLoading: boolean = false
    isPosting: boolean = false
    documentSigned: boolean = false
    showResults: boolean = false
    ticket: number = 0
    ticketLog: ticketLogModel[] = []
    showCommentButton: boolean = false
    showComment: boolean = false
    comment: string = ''
    extraAmount: extraAmountModel = { extraAmount: false, id: '' }

    mounted() {
        this.isLoading = true
        this.GilgameshApi.get('admin/ejercicios')
            .then(r => r as AxiosResponse<number[]>)
            .then(d => {
                this.ejercicios = d.data
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => this.isLoading = false)
    }

    get showExtraAmount(): boolean {
        return this.extraAmount.extraAmount == true
    }

    get hasLibro(): boolean {
        if (this.entidad.libro && this.entidad.libro > 0) {
            return true
        }
        return false;
    }

    get hasExpediente(): boolean {
        if (this.entidad.expediente) {
            return true
        }
        return false
    }

    get hasTitular(): boolean {
        if (this.entidad.titular && this.entidad.titular.numero) {
            return true
        }
        return false
    }

    get showPrintConstancia(): boolean {
        if (this.entidad && this.entidad.ticket) {
            return this.showResults;
        }
        return false
    }

    prevPage() {
        if (this.currentPage > 1) {
            this.currentPage--
        }
    }

    nextPage() {
        if (this.currentPage < this.pageCount) {
            this.currentPage++
        }
    }

    getTicketData() {
        if (!this.isLoading) {
            this.isLoading = true
            this.GilgameshApi.get(`certificaciones/certi/${this.certi}/${this.ejercicio}`)
                .then(r => r as AxiosResponse<certificacionModel>)
                .then(d => {
                    this.entidad = d.data
                    this.showResults = true
                    this.GilgameshApi.get('certificaciones/tipoCertificacion')
                        .then(r => r as AxiosResponse<tipoCertificacionModel[]>)
                        .then(d => {
                            this.tipoCertificacion = (d.data.find(x => x.tipoCertificacion === this.entidad.tipoCertificacion) || { tipoCertificacion: 0, nombre: '' }).nombre
                        })
                        .then(() => {
                            this.GilgameshApi.get('certificaciones/tipoEntidad')
                                .then(r => r as AxiosResponse<tipoEntidadModel[]>)
                                .then(d => {
                                    this.tipoEntidad = (d.data.find(x => x.tipoEntidad === this.entidad.tipoEntidad) || { tipoEntidad: 0, nombre: '' }).nombre
                                })
                                .catch(x => console.log('reason: ' + x))
                        })
                        .then(() => {
                            this.GilgameshApi.get(`certificaciones/${this.entidad.ticket}/history`)
                                .then(r => r as AxiosResponse<ticketLogModel[]>)
                                .then(d => {
                                    this.ticketLog = d.data
                                    if (this.ticketLog && this.ticketLog.length > 0) {
                                        this.ticketLog.forEach((x, i, m) => {
                                            if (i === 0) {
                                                x.icon = 'star'
                                                x.color = 'red lighten-2'
                                            }
                                            else if (i < m.length - 1) {
                                                x.icon = 'assignment'
                                                x.color = 'lime darken-2'
                                            }
                                            else {
                                                x.icon = 'assignment'
                                                x.color = 'indigo'
                                            }
                                        })
                                    }
                                }).then(() => {
                                    this.GilgameshApi.get(`certificaciones/${this.entidad.ticket}/requireExtraAmount`)
                                        .then(r => r as AxiosResponse<extraAmountModel>)
                                        .then(d => {
                                            console.log('extraAmount? ' + JSON.stringify(d.data))
                                            this.extraAmount = d.data
                                            return this.extraAmount.extraAmount
                                        }).then((ea) => {
                                            if (ea) {
                                                this.snackbar = true
                                                this.snackBarText = "Se requiere un pago adicional"
                                            }
                                            else {
                                                this.GilgameshApi.get(`certificaciones/${this.entidad.ticket}/certiFirmada`)
                                                    .then(r => r as AxiosResponse<boolean>)
                                                    .then(d => {
                                                        if (d.data) { //ya hay una certi firmada
                                                            printJS(`${process.env.VUE_APP_BACKEND_HOST}/certificaciones/${this.entidad.ticket}/certiFirmada/file`)
                                                        }
                                                        else {
                                                            this.snackbar = true
                                                            this.snackBarText = "La certificación aun no ha sido firmada"
                                                            this.showCommentButton = true
                                                        }
                                                    })
                                            }
                                        })
                                })
                        })
                        .catch(x => console.log('reason: ' + x))
                })
                .catch(x => {
                    console.log('reason: ' + x.response.status)
                    if (x.response.status === 404) {
                        this.snackbar = true
                        this.snackBarText = "La certificación ingresada no existe en el sistema"
                    }
                })
                .finally(() => this.isLoading = false)
        }
    }

    addComment() {
        if (!this.isLoading) {
            this.isLoading = true
            const msj = { comment: this.comment }
            this.GilgameshApi.post(`certificaciones/${this.entidad.ticket}/appendComment`, msj)
                .then(r => {
                    if (r.status === 200) {
                        this.GilgameshApi.get(`certificaciones/${this.entidad.ticket}/history`)
                            .then(r => r as AxiosResponse<ticketLogModel[]>)
                            .then(d => {
                                this.ticketLog = d.data
                                if (this.ticketLog && this.ticketLog.length > 0) {
                                    this.ticketLog.forEach((x, i, m) => {
                                        if (i === 0) {
                                            x.icon = 'star'
                                            x.color = 'red lighten-2'
                                        }
                                        else if (i < m.length - 1) {
                                            x.icon = 'assignment'
                                            x.color = 'lime darken-2'
                                        }
                                        else {
                                            x.icon = 'assignment'
                                            x.color = 'indigo'
                                        }
                                    })
                                }
                            })
                            .then(() => {
                                this.snackbar = true
                                this.snackBarText = "Se ha adicionado la anotación al expediente"
                                this.showComment = false
                            })
                    }
                })
                .catch(x => {
                    console.log('reason: ' + x.response.status)
                })
                .finally(() => this.isLoading = false)
        }
    }

    printConstancia() {
        printJS(`${process.env.VUE_APP_BACKEND_HOST}/certificaciones/${this.entidad.ticket}/comprobante`)
    }

    gotoKanban() {
        router.push({ name: 'kanban' })
    }

    goToDeposito() {
        router.push({ name: 'reportaDeposito', params: { token: this.extraAmount.id } })
    }
}
